import React from 'react';
import style from './FormSection.module.css';

interface FormSectionProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  /* §FB31: центральний слот шапки — кнопки дій картки (між заголовком і ТЕГом). */
  headerCenter?: React.ReactNode;
  headerRight?: React.ReactNode;
  children: React.ReactNode;
}

const FormSection: React.FC<FormSectionProps> = ({
  title,
  subtitle,
  icon,
  headerCenter,
  headerRight,
  children,
}) => (
  <div className={style.wrapInfo}>
    {(title || icon || headerCenter || headerRight) && (
      <div className={style.sectionHeader}>
        <div className={style.titleGroup}>
          {icon && <span className={style.sectionIcon}>{icon}</span>}
          {(title || subtitle) && (
            <div className={style.titleText}>
              {title && <h6>{title}</h6>}
              {subtitle && <p className={style.subtitle}>{subtitle}</p>}
            </div>
          )}
        </div>
        {headerCenter && (
          <div className={style.headerCenter}>{headerCenter}</div>
        )}
        {headerRight && <div className={style.headerRight}>{headerRight}</div>}
      </div>
    )}
    {children}
  </div>
);

export default FormSection;
